import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

const ProtectedRoute = ({ children }) => {
  const protectedPath = [
    '/profile',
    '/profile/transaction/detail-transaction',
    '/profile/transaction/invoice',
    '/profile/events',
    '/profile/webinars',
    '/subscription',
    '/subscription/payment-success',
    '/advisor/listing/buy-company/verification',
    '/buyer/listing/buy-company/verification',
    '/seller/listing/sell-company/verification',
    '/advisor/listing/sell-company/verification',
    '/advisor/listings/verification',
    '/buyer/listing/buy-company',
    '/advisor/listing/buy-company',
    '/seller/listing/sell-company',
    '/advisor/listings/advisor-profile',
    '/advisor/listing/sell-company',
    '/onboarding',
    '/valuation-page'
  ]
  const { pathname, state } = useLocation()
  const isAuth = useSelector((state) => state.auth)
  if (!isAuth?.access_token && protectedPath.find((path) => pathname.includes(path))) {
    if (!!state?.isFromOnboarding && pathname?.includes('/subscription')) {
      return children
    }
    return <Navigate to="/login" replace />
  }
  return children
}

export default ProtectedRoute
